import {API} from "@/js/accounts/utils/api.js";
import A11yDialog from 'a11y-dialog'


export default () => ({
    inviteUserEmail: '',
    async schoolInit() {
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        this.schoolDetails = window.accountDetails.school_details;
        this.editUsersDialog = null;
    },

    async makeUserAdmin(user_name, user_id, school_id) {
        if (!confirm(`Are you sure you want to make ${user_name} an admin?`)) {
            return;
        }

        const response = await API.POST.affiliation(this.csrfToken, user_id, {
            AffiliationType: {Id: 10053},
            GroupConstituent: {Id: school_id},
            IndividualConstituent: {Id: user_id},
        })
        if (!response.ok) {
            const errorData = await response.json();
            this.errors = errorData;
            return;
        }
        const data = await response.json();
        alert(`${user_name} is now an admin.`);
        window.location.reload();
    },

    async removeUserFromGroup(user_name, affiliation_id) {
        if (!confirm(`Are you sure you want to remove ${user_name} from this school?`)) {
            return;
        }

        const response = await API.DELETE.affiliation(this.csrfToken, affiliation_id)
        if (!response.ok) {
            const errorData = await response.json();
            this.errors = errorData;
            return;
        }
        const data = await response.json();
        alert(`${user_name} has been removed from this school.`);
        window.location.reload();
    },

    triggerEditUsersModal() {
        const editUsersModal = document.getElementById('edit-users-modal');

        if (!this.editUsersDialog) {
            this.editUsersDialog = new A11yDialog(editUsersModal);

            this.editUsersDialog.on('show', () => {
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                document.body.style.setProperty('--scroll-y', `${scrollY}px`);
                document.body.classList.add('modal--open');
            });

            this.editUsersDialog.on('hide', () => {
                const scrollY = parseInt(document.body.style.getPropertyValue('--scroll-y') || '0');
                document.body.classList.remove('modal--open');
                window.scrollTo(0, scrollY);
            });
        }

        this.editUsersDialog.show();
    },
    async sendInviteLink(e) {
        const target = e.target;
        const form = target.closest('form');
        form.reportValidity();

        const payload = {
            email: this.inviteUserEmail,
            organisationConstituentId: form.dataset?.organisationConstituentId,
            membershipId: form.dataset?.membershipId,
        };

        try {
            const response = await API.POST.inviteUser(this.csrfToken, payload)

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            alert('Invite sent successfully!');
            this.inviteUserEmail = '';
        } catch (error) {
            alert('There was an error sending the invite. Please try again.');
        }

    }
});
